import React from 'react'
import styled from 'styled-components'

import Header from './Header/Header'
import MonoHeader from './Header/MonoHeader'

import Kiosk from '../Kiosk/Kiosk'
import MonoKiosk from './Kiosk/MonoKiosk'
import MenuKiosk from './Kiosk/MenuKiosk'

import Settings from 'settings'

import { KioskWrapper, MasonryWrapper } from './style'
import NoDataSegment from '../NoDataSegment/NoDataSegment'

import DuoKiosk from './Kiosk/DuoKisok'
import MenuPrice from './Kiosk/MenuPrice'
import MonoFooter from './Kiosk/MonoFooter'
import { getLanguage } from '../../utils/Locale'

const EmptyMenu = props => (
    <img
        style={{ maxWidth: '80%', height: 'auto' }}
        src={`img/no_menu_${props.lang}.png`}
    />
)

const kioskView = props => {
    const {
        isReady,
        useCommercialName,
        hideComposition,
        hideLabels,
        hideIntolerences,
        dataSource,
        isAdministrationPanel,
        language,
        title,
        subtitle,
        columns,
    } = props

    if (!isReady) {
        return null
    }

    if (!props.items || props.items.length === 0) {
        if (!isAdministrationPanel) {
            return <EmptyMenu lang={language} />
        }
        return (
            <NoDataSegment message="There is not enough data to show the menu." />
        )
    }

    const headerTitle =
        title || Settings.translations[getLanguage(language)].today

    const breakpointColumnsObj = {
        default: parseInt(columns) || 3,
        1650: 2,
        1079: 1,
    }

    if (!props.items.kiosks || props.items.kiosks.length === 0) {
        if (!isAdministrationPanel) {
            return <EmptyMenu lang={language} />
        }
        return (
            <NoDataSegment message="There is not enough data to show the menu." />
        )
    }

    if (props.isDuoKiosk) {
        return <DuoKiosk {...props} />
    }

    const isMultiKiosk = props.items.kiosks.length > 1
    const kioskName = !isMultiKiosk && props.items.kiosks[0].name
    const monoKioskPicture = !isMultiKiosk && props.items.kiosks[0].kioskPicture

    let isKiosksEmpty = true
    if (props.items.kiosks && props.items.kiosks.length) {
        props.items.kiosks.map(kiosk => {
            if (kiosk.items.length) {
                isKiosksEmpty = false
            }
        })
    }

    const items =
        props.menu === '' ? (
            props.items.kiosks.map((kiosk, index) =>
                isMultiKiosk ? (
                    <KioskWrapper key={index} zoom={props.zoom}>
                        <Kiosk
                            name={kiosk.name}
                            displayName={kiosk.displayName}
                            items={kiosk.items}
                            concept={props.concept}
                            currency={props.currency}
                            kioskPicture={kiosk.kioskPicture}
                            useCommercialName={useCommercialName}
                            dataSource={dataSource}
                            hideMenuPrice={props.hideMenuPrice}
                            hideRecipePoints={props.hideRecipePoints}
                            hideEnergyKcal={props.hideEnergyKcal}
                            showEnergyKcalByPortion={props.showEnergyKcalByPortion}
                            hideComposition={hideComposition}
                            hideLabels={hideLabels}
                            hideIntolerences={hideIntolerences}
                        />
                    </KioskWrapper>
                ) : (
                    <MonoKiosk
                        items={kiosk.items}
                        kioskPicture={kiosk.kioskPicture}
                        zoom={props.zoom}
                        key={index}
                        currency={props.currency}
                        useCommercialName={useCommercialName}
                        dataSource={dataSource}
                        hideMenuPrice={props.hideMenuPrice}
                        hideRecipePoints={props.hideRecipePoints}
                        hideEnergyKcal={props.hideEnergyKcal}
                        showEnergyKcalByPortion={props.showEnergyKcalByPortion}
                        hideComposition={hideComposition}
                        hideLabels={hideLabels}
                        hideIntolerences={hideIntolerences}
                        defaultColumnsCount={1}
                    />
                )
            )
        ) : (
            <MenuKiosk
                items={props.items.menus[props.menu]}
                concept={props.concept}
                zoom={props.zoom}
                currency={props.currency}
                useCommercialName={useCommercialName}
                dataSource={dataSource}
                hideMenuPrice={props.hideMenuPrice}
                hideRecipePoints={props.hideRecipePoints}
                hideEnergyKcal={props.hideEnergyKcal}
                showEnergyKcalByPortion={props.showEnergyKcalByPortion}
                hideComposition={hideComposition}
                hideLabels={hideLabels}
            />
        )

    const content =
        props.menu === '' ? (
            isMultiKiosk ? (
                <div>
                    <Header
                        title={headerTitle}
                        subtitle={props.subtitle}
                        concept={props.concept}
                        titleFontSize={'2.4em'}
                        mode="kiosk"
                    />
                    {!props.hideMenuPrice && <MenuPrice {...props} />}
                    {isKiosksEmpty ? (
                        <EmptyMenu lang={language} />
                    ) : (
                        <MasonryWrapper breakpointCols={breakpointColumnsObj}>
                            {items}
                        </MasonryWrapper>
                    )}
                </div>
            ) : (
                <div>
                    <MonoHeader
                        kioskName={kioskName}
                        concept={props.concept}
                        monoKioskPicture={monoKioskPicture}
                        useCommercialName={useCommercialName}
                    />
                    {!props.hideMenuPrice && <MenuPrice {...props} />}
                    {isKiosksEmpty ? <EmptyMenu lang={language} /> : items}
                    <MonoFooter kiosk={monoKioskPicture} fullWidth />
                </div>
            )
        ) : (
            <div>
                <MonoHeader
                    menu={props.menu}
                    concept={props.concept}
                    monoKioskPicture={monoKioskPicture}
                />
                {isKiosksEmpty ? <EmptyMenu lang={language} /> : items}
            </div>
        )

    return content
}

export default kioskView

const Grid = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    .item {
        position: relative;
        background-color: #fff;
        margin: 8px;
        padding-top: 2px;
        border-radius: 3px;
        box-shadow: 0 1px 6px rgba(21, 24, 88, 0.05);
        transition: box-shadow 0.5s ease-in-out,
            -webkit-box-shadow 0.5s ease-in-out;
        border: 1px solid #d5d5d5;
    }
`
